var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('page-title-icon',{staticClass:"m-bottom-md",attrs:{"title":"音乐服务","sub":"我们能为音乐人做些什么？"}}),_c('page-progress',{attrs:{"list":_vm.List}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }